import {
  Home, BookOpen, Sparkles, Bot, Settings, CalendarDays, Sun, Images,
  Baby, Trophy, MapPin, NotebookPen, Bookmark, Radio, Info, Landmark, Clock,
  MessageSquareHeart,   // ✅ NEW
} from "lucide-react";

// Full menu (mirrors the app Sidebar).
export const MENU = [
  { section: "Daily", items: [
    { key: "home", title: "Home", route: "/", icon: Home },
    { key: "nitnem", title: "Nitnem", route: "/nitnem", icon: BookOpen },
    { key: "hukamnama", title: "Hukamnama", route: "/hukamnama", icon: Sun },
    { key: "simran", title: "Simran", route: "/simran", icon: Sparkles },
    { key: "inspiration", title: "Guru Inspiration", route: "/inspiration", icon: Landmark, badge: "IN ⌛PROGESS" },
  ]},
  { section: "Community", items: [
    { key: "events", title: "Events", route: "/events", icon: CalendarDays },
    { key: "gallery", title: "Gallery", route: "/gallery", icon: Images },
    { key: "kids", title: "Kids Mode", route: "/kids", icon: Baby, badge: "SOON" },
    { key: "quest", title: "Sikh Quest", route: "/quest", icon: Trophy },
    { key: "yatra", title: "Digital Yatra", route: "/yatra", icon: MapPin },
    {
  key: "getgursetu",
  title: "Get GurSetu App",
  route: "/get-gursetu",
  badge: "NEW",
},
  ]},
  { section: "Journal", items: [
    { key: "hukam-journal", title: "Hukam Journal", route: "/hukam-journal", icon: NotebookPen },
    { key: "bookmarks", title: "Bookmarks", route: "/bookmarks", icon: Bookmark },
    { key: "ai", title: "AI Sahayak", route: "/ai", icon: Bot },
    { key: "kirtan", title: "Live Kirtan", route: "/kirtan", icon: Radio },
  ]},
  { section: "Coming Soon", items: [
    { key: "sevasetu", title: "SevaSetu", route: "#", icon: Clock, badge: "Soon", disabled: true },
    { key: "one-min", title: "One Minute with Waheguru", route: "#", icon: Clock, badge: "Soon", disabled: true },
    { key: "gurcast", title: "GurCast", route: "#", icon: Clock, badge: "Soon", disabled: true },
  ]},
 { section: "More", items: [
  { key: "calendar", title: "Calendar", route: "/calendar", icon: CalendarDays },
  { key: "settings", title: "Settings", route: "/settings", icon: Settings },
  { key: "feedback", title: "Feedback & Queries", route: "#feedback", icon: MessageSquareHeart },  // ✅ NEW
  { key: "about", title: "About", route: "/about", icon: Info },
]},
];

// Bottom-nav (mobile) — matches the app's 5 tabs.
export const TABS = [
  { key: "home", title: "Home", route: "/", icon: Home },
  { key: "calendar", title: "Calendar", route: "/calendar", icon: CalendarDays },
  { key: "simran", title: "Simran", route: "/simran", icon: Sparkles },
  { key: "ai", title: "Sahayak", route: "/ai", icon: Bot },
  { key: "settings", title: "Settings", route: "/settings", icon: Settings },
];
